import { Component, OnInit } from '@angular/core';
import { GraphService } from '../../General/graph/graph.service';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { TeacherGraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/teacher-graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { GraphAlgorithm, GraphServiceJson, ITree, GraphRandom } from 'graph-interactive';
import { TreeUU } from '../../shared/interactive-graph/simple_tree/treeUU';

@Component({
  selector: 'app-t-vertex-cover',
  templateUrl: './t-vertex-cover.component.html',
  styleUrls: ['./t-vertex-cover.component.css']
})
export class TVertexCoverComponent extends TeacherGraphExerciseComponent {
  private readonly canvasID: string = 'graph-canvas';
  private readonly vertexCoverID: string = 'vertexCoverButton';

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, graphService: GraphService) {
    super(topicsService, activatedRoute);
    this.type = 'vertexCover';
    this.title = this.get('vertexCover');
    this.description = this.get('descriptionVertexCover');
  }

  
  generate(){
    GraphRandom.generateGraph(this.graph);
  }
  
  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };
    const vertexCoverButton = <HTMLButtonElement>document.getElementById(this.vertexCoverID);
    vertexCoverButton.addEventListener('click', this.findVertexCover, false);
  }
  
  initGraph(): InteractiveGraph{
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); 
    return new GraphUU(canvas);
   // return new TreeUU(canvas);
  }

  //Called, when the find vertex cover button is clicked.
  findVertexCover = (e: Event) => {
      
      let vc = GraphAlgorithm.vertexCover(this.graph.getGraph());
      this.graph.highLight(vc, null);
   /*   if(this.graph instanceof ITree){
          this.graph.buildCombinatorialTree(['a','b', 'c','e'], 3, true);
          console.log("Call buildCombinatorial");
          this.graph.forceUpdate();
      }*/
  }

  //We store the current graph in a json
  generateDefinition(): any {
    const definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = './assets/images/vertexCover.png';
    definition.key = 'vertexCover%'.concat(this.type, '%' + this.id);
    if (this.examId > -1) {
      definition.key = definition.key.concat('exam%', this.examId.toString(), '%');
    }

    GraphServiceJson.exportGraph(this.graph, definition);
    return definition;
  }

  /**
   * We restore the graph from the json-file
   */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration(); 
  }

}


